var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseCircleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187 -280) translate(187 280)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    fillRule: "nonzero",
    d: "M15.118 8l.882.882L12.881 12 16 15.118l-.882.882L12 12.881 8.882 16 8 15.118 11.118 12 8 8.882 8.882 8 12 11.118 15.118 8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseCircleGray);
export default __webpack_public_path__ + "static/media/ic_close_circle_gray.16c65bef777d55fb5672f64ef2023442.svg";
export { ForwardRef as ReactComponent };